<template>
  <div>
    <v-progress-linear v-if="loading"
                       indeterminate
                       color="green"
    ></v-progress-linear>

    <!--    <div class="row" v-else>-->
    <div class="row" v-else>
      <div class="col-md-6">
        <v-card class="mt-4">
          <v-card-title>Базовые параметры</v-card-title>
          <v-card-text class="pt-0 ">
            <div class="subheading black--text">
              <v-simple-table dense>
                <template #default>
                  <tbody>
                  <tr>
                    <td><b>Проект</b></td>
                    <td>{{ tariff['basic']['project_name'] }}</td>
                  </tr>
                  <tr>
                    <td><b>Название тарифа</b></td>
                    <td>{{ tariff['tariff_name'] }}</td>
                  </tr>
                  <tr>
                    <td><b>Номер договора</b></td>
                    <td>{{ tariff['contract_number'] }}</td>
                  </tr>
                  <tr>
                    <td><b>Номер приложения</b></td>
                    <td>{{ tariff['application_number'] }}</td>
                  </tr>
                  <tr>
                    <td><b>Стоимость менеджмента</b></td>
                    <td>{{ tariff['basic']['management_cost'] }} руб.</td>
                  </tr>
                  <tr>
                    <td><b>Стоимость пакета минут</b></td>
                    <td>{{ tariff['basic']['package_cost'] }} руб.</td>
                  </tr>
                  <tr>
                    <td><b>Кол-во минут в пакете</b></td>
                    <td>{{ tariff['basic']['package_limit'] }}</td>
                  </tr>
                  <tr>
                    <td><b>Тип тарификации: посекундная \ поминутная</b></td>
                    <td>{{ tariff['basic']['tariffication_type'] }}</td>
                  </tr>
                  <tr>
                    <td><b>Стоимость работы в ЦРМ</b></td>
                    <td>{{ tariff['basic']['crm_cost'] }}</td>
                  </tr>
                  <tr>
                    <td><b>Стоимость при превышении лимита</b></td>
                    <td>{{ tariff['basic']['overlimit_minute_cost'] }}</td>
                  </tr>
                  <tr>
                    <td><b>Начало работы тарифа</b></td>
                    <td>{{ utils.formattingStringWithTime(tariff['basic']['started_at'], 'YYYY-MM-DD') }}</td>
                  </tr>
                  <tr>
                    <td><b>Окончание работы тарифа</b></td>
                    <td>{{ tariff['basic']['closed_at'] === null ? '-'
                        : utils.formattingStringWithTime(tariff['basic']['closed_at']) }}</td>
                  </tr>
                  <tr>
                    <td><b>Очереди привязанные к тарифу</b></td>
                    <td>
                      <v-chip-group>
                        <v-chip v-for="(queue, index) in tariff['basic']['queues']" :key="index" style="cursor: auto;">
                          {{ queue['name'] }} {{ queue['dname'] }}
                        </v-chip>
                      </v-chip-group>
                    </td>
                  </tr>

                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </v-card-text>
        </v-card>
      </div>

      <div class="col-md-6">
        <v-card class="mt-4">
          <v-card-title>Расчетные параметры</v-card-title>
          <v-card-text class="pt-0 ">
            <div class="subheading black--text">
              <v-simple-table dense>
                <template #default>
                  <tbody>
                  <tr>
                    <td><b>Итоговая стоимость менеджмента</b></td>
                    <td style="width: 20%;">{{ tariff['management_work_cost'] }} руб.</td>
                  </tr>
                  <tr>
                    <td><b>Итоговая стоимость пакета</b></td>
                    <td>{{ tariff['final_package_cost'] }} руб.</td>
                  </tr>
                  <tr>
                    <td><b>Итоговая стоимость ЦРМ</b></td>
                    <td>{{ tariff['crm_work_cost'] }} руб.</td>
                  </tr>
                  <tr>
                    <td><b>Итоговая стоимость превышения минут</b></td>
                    <td>{{ tariff['over_limit_cost'] }} руб.</td>
                  </tr>
                  <tr>
                    <td><b>Итоговая сумма по тарифу за выбранный период</b></td>
                    <td>{{ tariff['total_cost'] }} руб.</td>
                  </tr>
                  <tr>
                    <td>
                      <b>Кол-во отработанных дней за выбранный период с начала месяца, либо с даты начала тарифа</b>
                    </td>
                    <td>{{ tariff['detailed']['worked_days'] }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>Кол-во оставшихся дней до конца месяца, либо до конца действия тарифа в зависимости от того,
                      что наступит раньше</b>
                    </td>
                    <td>{{ tariff['detailed']['left_days_in_month'] }}</td>
                  </tr>
                  <tr>
                    <td><b>Суммарное кол-во дней в месяце, которое проработает тариф</b></td>
                    <td>{{ tariff['detailed']['tariff_will_work'] }}</td>
                  </tr>
                  <tr>
                    <td><b>Дней в месяце</b></td>
                    <td>{{ tariff['detailed']['days_in_month'] }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>Выговоренно минут за выбранный период с начала месяца, либо с начала работы тарифа, до конца
                      вчерашнего дня включительно</b>
                    </td>
                    <td>{{ tariff['current_min'] }} мин.</td>
                  </tr>
                  <tr>
                    <td><b>Прогноз минут</b></td>
                    <td>{{ tariff['predict'] }} мин.</td>
                  </tr>
                  <tr>
                    <td><b>Прогнозируемое превышение минут</b></td>
                    <td>{{ tariff['excess'] }} мин.</td>
                  </tr>

                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </v-card-text>
        </v-card>
      </div>
    </div>

  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "TarifficationModal",
  props: {
    value: {
      type: Boolean,
    },
    projectId: {
      type: Number,
    },
    period: {
      type: Array,
    },
    packageType: {
      type: Number,
    },
    tariffId: {
      type: Number,
    },
  },

  data() {
    return {
      loading: true,
    }
  },

  computed: {
    ...mapGetters({
      tariff: 'tariffications/tariff',
    }),
    payload() {
      return {
        projects: [this.projectId],
        period: this.period,
        package_type: this.packageType,
        tariff_id: this.tariffId,
        with: 'basic,detailed',
      }
    },
  },

  mounted() {
    this.loadTarifficationsReport(this.payload)
        .finally(() => {
          this.loading = false;
        });
  },

  methods: {
    ...mapActions({
      loadTarifficationsReport: 'tariffications/loadTarifficationsReport',
    }),

    close() {
      this.$emit('input', false);
    },
  },
}
</script>

<style scoped>

</style>